/**
 * @see predict-performance-calculation src/Factory/SplitterHandler.ts
 */
export enum StaticCost {
  NORMAL = "StaticUseDynamic",
  STATIC = "StaticPeak",
}